// CarCardComponent.js
import Link from "next/link";
import styles from "@/components/ui/cards/CarCardComponent.module.css";
import AttributeComponent from "@/components/ui/cards/attributes/AttributeComponent";
import PriceIndicator from "@/components/ui/cards/attributes/PriceIndicator";
import Image from "next/image";

const CarCardComponent = ({car}) => {
  const {make, model, year, vehicle_id, description, images, attributes, basic_details, price_category, status} = car;

  const getStatusText = (statusCode) => {
    switch (statusCode) {
      case 0:
        return 'Available used';
      case 1:
        return 'Available new';
      case 2:
        return 'Pre-order';
      case 3:
        return 'Coming soon';
      case 91:
        return 'Coming soon';
      default:
        return 'Concept car'; // Fallback for unknown codes
    }
  };


  function formatDescription(make, model, description, vehicle_id) {
    // Convert inputs to lowercase and replace hyphens with spaces
    make = make.toLowerCase().replace(/-/g, ' ');
    model = model.toLowerCase().replace(/-/g, ' ');

    // Remove hyphens in the description for comparison
    let formattedDescription = description.toLowerCase().replace(/-/g, ' ');

    // Remove make and model from the description
    formattedDescription = formattedDescription.replace(make, '').replace(model, '').trim();

    // Replace 'kwh' with 'kWh'
    formattedDescription = formattedDescription.replace(/kwh/g, 'kWh');

    // Check if the last segment is the vehicle ID and remove it if it is
    let parts = formattedDescription.split(' ');
    if (parts[parts.length - 1] === vehicle_id.toString()) {
      parts.pop();
    }
    formattedDescription = parts.join(' ');

    // Capitalize the first letter of each word
    formattedDescription = formattedDescription.replace(/\b\w/g, (char) => char.toUpperCase());

    return formattedDescription;
  }

  // Determine the source of the image
  const hasImages = Array.isArray(images) && images.length > 0;
  const imageUrl = hasImages ? images[0].image_url : '/illustrations/v2/EV-v1.png';
  const imageClassName = hasImages ? styles.cardImage : styles.fallBackImage;
  const containerClassName = hasImages ? styles.imageContainer : styles.fallbackImageContainer;

  return (
    <div className={styles.card}>
      <Link href={`/directory/${car.slug}`}>
        <div className={containerClassName}>
          <img
            className={imageClassName}
            src={imageUrl}
            alt={`${make} ${model}`}
          />
        </div>
      </Link>
      <h2 className={styles.cardTitle}>
        <Link href={`/directory/${car.slug}`}>{`${make} ${model} ${basic_details[2].value}`}</Link>
      </h2>
      <div className={styles.cardYear}>{year}</div>
      <div className={styles.cardDescription}>{formatDescription(make, model, description, vehicle_id)}</div>
      <div className={styles.attributeValue}>
        <PriceIndicator min_price_category={price_category} max_price_category={price_category}/>
      </div>
      <div className={styles.attributeValue}>
        {getStatusText(status)}
      </div>
      <div className={styles.cardAttributes}>
        {attributes
          .sort((a, b) => a.cw_position - b.cw_position)
          .map((attribute, index) => (
            <AttributeComponent key={index} attribute={attribute}/>
          ))}
      </div>
    </div>
  );
};

export default CarCardComponent;
